import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { format } from 'date-fns'

import {
  NewsBoxStyled,
  NewsBoxMediaStyled,
  NewsBoxContentStyled,
  NewsBoxContentDateStyled,
  NewsBoxContentCategoryStyled,
  NewsBoxContentTitleStyled
} from './styles'
import { NewsBoxProps } from './types'
import Link from 'gatsby-link'

const NewsBox: React.FC<NewsBoxProps> = ({ data, url: to, isSmall }) => {
  const { postedat, title, imageurl, category } = data

  return (
    <NewsBoxStyled as={Link} {...{ isSmall, to }}>
      <NewsBoxMediaStyled>{imageurl && <LazyLoadImage src={imageurl} alt={title} effect="blur" />}</NewsBoxMediaStyled>
      <NewsBoxContentStyled>
        <NewsBoxContentDateStyled>{format(new Date(postedat.substring(0, 10)), 'MMMM dd, yyyy')}</NewsBoxContentDateStyled>
        <NewsBoxContentCategoryStyled>{category}</NewsBoxContentCategoryStyled>
        <NewsBoxContentTitleStyled>{title}</NewsBoxContentTitleStyled>
      </NewsBoxContentStyled>
    </NewsBoxStyled>
  )
}

export default NewsBox
